function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "primary/blocked",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M15,30 C6.715728,30 0,23.284272 0,15 C0,6.715728 6.715728,0 15,0 C23.284272,0 30,6.715728 30,15 C30,23.284272 23.284272,30 15,30 Z M17.7165,11.50823 L17.7165,6.10823 L13.2345,6.10823 L13.2345,11.50823 L14.7465,18.04223 L16.1775,18.04223 L17.7165,11.50823 Z M17.2305,24.09023 L17.2305,20.44523 L13.6665,20.44523 L13.6665,24.09023 L17.2305,24.09023 Z",
  id: "Combined-Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    version: 1.1
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/blocked-icon.9f8011e7.svg";
export { SvgComponent as ReactComponent };